import React from "react";

const ForbiddenPage = () => (
  <div
    className="d-flex flex-column align-items-center justify-content-center"
    style={{ minHeight: "60vh" }}
  >
    <i className="fa-solid fa-lock fs-1 mb-4"></i>
    <h2 className="mb-2">Acceso denegado</h2>
    <p className="text-muted">No tienes permisos para acceder a este módulo.</p>
  </div>
);

export default ForbiddenPage;
